import { useEffect } from "react";

import { insertScript, removeNode } from "../../../js/utils/functions";
import { RECAPTCHA_URL } from "../../../packs/grecaptcha";

const ReCaptchaV3 = ({ sitekey }) => {
  useEffect(() => {
    // add Google's reCaptcha V3 script to the body
    const url = `${RECAPTCHA_URL}?render=${sitekey}`;
    const script = insertScript(url);
    // cleaning:
    return () => {
      removeNode(script);
    };
  }, []);

  return null;
};

export default ReCaptchaV3;
